<template>
  <ParticipantsDashboard :profileId="profileId" :isCompanyAdmin="isCompanyAdmin" />
</template>

<script>
import ParticipantsDashboard from '@/views/ParticipantsDashboard.vue'
export default {
  components: { ParticipantsDashboard },
  computed: {
    profileId() {
      return this.$route.params.id
    },
    isCompanyAdmin() {
      return true
    }
  },
}
</script>
